export const roles = ["ADMIN", "INVESTOR"];
